export default {
    "zh-cn": {
        "gui.menuBar.myWork": "我的作品",
        "gui.menuBar.goHome": "回到官网",
        "gui.menuBar.login": "登录",
        "gui.more.functions": "更多功能",
        "gui.libraryTags.holiday": "节假日",
        "gui.alerts.updateError": "无法找到该作品",
        "gui.gui.HowToUseCloud": "登录保存作品后方可启用云变量功能",
        'gui.libraryTags.guard_watermelon': '保卫西瓜',
        'gui.libraryTags.spring_estival_couplets': '对春联',
        'gui.libraryTags.christmas_special': '圣诞特辑',
        'gui.libraryTags.starstation': '星空',
        'gui.libraryTags.JourneyWest': '西游记',
        'gui.libraryTags.知乎': '知乎',
        'gui.libraryTags.photo_album': '电子相册',
    },
    "en": {
        "gui.menuBar.myWork": "my projects",
        "gui.menuBar.goHome": "homepage",
        "gui.menuBar.login": "login",
        "gui.more.functions": "more functions",
        "gui.libraryTags.holiday": "holiday",
        "gui.alerts.updateError": "can not find this work",
        'gui.libraryTags.guard_watermelon': 'guard watermelon',
        'gui.libraryTags.spring_estival_couplets': 'spring_estival_couplets',
        'gui.libraryTags.christmas_special': 'christmas_special',
        'gui.libraryTags.starstation': 'starstation',
        'gui.libraryTags.JourneyWest': 'JourneyWest',
        'gui.libraryTags.知乎': 'ZhiHu',
        'gui.libraryTags.photo_album': 'photo_album',
    },
    "zh-tw": {
        "gui.menuBar.myWork": "我的作品",
        "gui.menuBar.goHome": "官網",
        "gui.menuBar.login": "登入",
        "gui.more.functions": "更多",
        "gui.libraryTags.holiday": "節假日",
        "gui.alerts.updateError": "無法找到該作品",
        'gui.libraryTags.guard_watermelon': 'guard watermelon',
        'gui.libraryTags.spring_estival_couplets': 'spring_estival_couplets',
        'gui.libraryTags.christmas_special': 'christmas_special',
        'gui.libraryTags.starstation': 'starstation',
        'gui.libraryTags.JourneyWest': 'JourneyWest',
        'gui.libraryTags.知乎': 'ZhiHu',
        'gui.libraryTags.photo_album': 'photo_album',
    },
    "ja": {
        "gui.menuBar.myWork": "私の作品",
        "gui.menuBar.goHome": "公式サイト",
        "gui.menuBar.login": "アカウントログイン",
        "gui.more.functions": "もっと",
        "gui.libraryTags.holiday": "しゅくじつ",
        "gui.alerts.updateError": "この作品が見つかりませんでした",
        'gui.libraryTags.guard_watermelon': 'guard watermelon',
        'gui.libraryTags.spring_estival_couplets': 'spring_estival_couplets',
        'gui.libraryTags.christmas_special': 'christmas_special',
        'gui.libraryTags.starstation': 'starstation',
        'gui.libraryTags.JourneyWest': 'JourneyWest',
        'gui.libraryTags.知乎': 'ZhiHu',
        'gui.libraryTags.photo_album': 'photo_album',
    }
}
